import StepStore from "@dashboard/modules/shared/components/onboarding-shared/pages/step-store/step-store";
import { FC } from "react";

const OnboardingStore: FC = () => {
  return <StepStore ctaSelectTemplate="templates" />;
};

export default OnboardingStore;
